import React from 'react';

import * as Styled from './form-body.style';

export type MonthDayGridProps = {
  days: readonly number[];
  selectedDays: number[];
  onToggleDay: (day: number) => void;
  disabled?: boolean;
};

export const MonthDayGrid: React.FC<MonthDayGridProps> = ({
  days,
  selectedDays,
  onToggleDay,
  disabled,
}) => (
  <Styled.MonthDayList>
    {days.map((monthDay) => {
      const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        onToggleDay(monthDay);
      };

      return (
        <Styled.MonthDayListItem key={monthDay}>
          <Styled.DayButton
            onClick={handleClick}
            $selected={selectedDays.includes(monthDay)}
            disabled={disabled}
            type="button"
          >
            {monthDay}
          </Styled.DayButton>
        </Styled.MonthDayListItem>
      );
    })}
  </Styled.MonthDayList>
);
